class HHProductCard extends HTMLElement {
  constructor() {
    super();

    this.productHandle = this.getAttribute('product-handle')
  }

  get shouldHydrate() {
    return this.hasAttribute('hydrate');
  }

  connectedCallback() {
    if (this.shouldHydrate) {
      this.hydrate();
    }
  }

  declineProduct(handle) {
    const recentlyViewedProducts = JSON.parse(localStorage.getItem('recently_viewed_products')) || []
    if (recentlyViewedProducts.includes(handle)) {
      const index = recentlyViewedProducts.indexOf(handle)
      recentlyViewedProducts.splice(index, 1)
      localStorage.setItem('recently_viewed_products', JSON.stringify(recentlyViewedProducts));
      document.dispatchEvent(new CustomEvent('RECENTLY_VIEWED_RELOAD'))
    }
    this.remove()
  }

  async hydrate() {
    if (!this.productHandle) {
      return;
    }

    try {
      let url = `${window.Shopify.routes.root}products/${this.productHandle}?section_id=product-card`
      const request = await fetch(url)
      if (!request.ok) return this.declineProduct(this.productHandle) // May return 404 if product is unavailable
      const container = document.createElement('div')
      container.innerHTML = await request.text()
      const productCardNode = container.querySelector('hh-product-card')
      if (!productCardNode) return this.declineProduct(this.productHandle) // May return empty div if variant is unavailable
      this.innerHTML = productCardNode.innerHTML

      this.removeAttribute('hydrate');
    } catch(e) {
      console.error('Failed to hydrate product card', e)
    }
  }
}

customElements.define('hh-product-card', HHProductCard);
